import { TranslationKey, useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { S_AnnotationStatus } from '../../../annotations/annotationStatus/S_AnnotationStatus';
import { GROUND_TRUTH } from '../../jobPredictions.model';

interface IProps {
  groundTruth: string | null | undefined;
  score: number | null;
}

export const AnomalyDetection = ({ groundTruth, score }: IProps): ReactElement => {
  const { t } = useTranslator();

  let anomalyClass = '';
  let anomalyText: TranslationKey = 'na';
  if (groundTruth === GROUND_TRUTH.BAD) {
    anomalyClass = 'rejected';
    anomalyText = 'prediction.annotation.bad';
  } else if (groundTruth === GROUND_TRUTH.GOOD) {
    anomalyClass = 'approved';
    anomalyText = 'prediction.annotation.good';
  }

  return (
    <div className='attributes'>
      <span className='attribute'>
        {t('prediction.score')}: <S_AnnotationStatus text={score !== null ? score.toFixed(3) : t('na')} />
      </span>
      {groundTruth !== undefined && (
        <span className='attribute'>
          {t('prediction.annotation.text')}:{' '}
          <S_AnnotationStatus
            className={anomalyClass}
            text={t(anomalyText)}
          />
        </span>
      )}
    </div>
  );
};
